<template>
  <div>
    <v-card flat :style="`border: 4px solid ${colorByStatus}; border-radius: 8px`">
      <v-card-text>
        <div>{{ titleText }}</div>
        <h3 class="text-xs-right">{{ quantity }}</h3>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    quantity: {
      type: Number,
      default: 0
    }
  },
  computed: {
    titleText() {
      let text = ''
      if (this.title) {
        const allTitle = {
          send_total: 'จำนวนที่ส่งทั้งหมด',
          no_reach_total: 'เข้าถึงผู้ใช้ทั้งหมด',
          no_unreach_total: 'ไม่ถึงผู้ใช้ทั้งหมด'
        }
        text = allTitle[`${this.title}`]
      }

      return text
    },
    colorByStatus() {
      let color = '#FDB813'
      if (this.title) {
        if (this.title === 'no_reach_total') {
          color = '#3EE30A'
        } else if (this.title === 'no_unreach_total') {
          color = '#EE7970'
        }
      }

      return color
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/features/tcp/Broadcast/BroadcastTotalQtyByStatusCard.vue